import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=4b2b3118&scoped=true&lang=pug&"
import script from "./fees.vue?vue&type=script&lang=js&"
export * from "./fees.vue?vue&type=script&lang=js&"
import style0 from "./fees.vue?vue&type=style&index=0&id=4b2b3118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b3118",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/mortgages?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231201105121%2Fcomponents%2Fproducts%2Fmortgages%2Ffees.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports